module.exports = __webpack_public_path__ + "static/media/08B.2d2ecf50.png";